var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMosaicSixteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3999,
    y: 6,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7998,
    y: 6,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 6,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6001,
    y: 6,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9.75,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3999,
    y: 9.75,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7998,
    y: 9.75,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 9.75,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6001,
    y: 9.75,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13.5,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3999,
    y: 13.5,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7998,
    y: 13.5,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 13.5,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6001,
    y: 13.5,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17.25,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3999,
    y: 17.25,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7998,
    y: 17.25,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 17.25,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6001,
    y: 17.25,
    width: 2.4,
    height: 1.75,
    rx: 0.875,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicSixteen);
export default __webpack_public_path__ + "static/media/mosaic-sixteen.4b81291e7deb23b6a35098283a8b7290.svg";
export { ForwardRef as ReactComponent };